import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular'; 

import { QuestionBoxComponent } from './question-box.component';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [QuestionBoxComponent],
  imports: [CommonModule, IonicModule],
  exports: [QuestionBoxComponent]
})
export class QuestionBoxModule {}
